/**
 * Layout component that queries for data
 */
import React from "react"
import { Link } from "gatsby"
import { StaticQuery, graphql } from "gatsby";
import useDarkMode from 'use-dark-mode';

import "./../styles/main.scss"
import logoLight from "./../images/logo.svg"
import logoDark from "./../images/logo-dark.svg"


const Layout = ({ children }) => {
  const darkMode = useDarkMode(false);

  let logo = logoLight;
  if(darkMode.value) {
    logo = logoDark;
  }

  return (

    <StaticQuery
      query={graphql`
        query LayoutQuery {
          datoCmsHomepage {
            shortDescription
            socialMedia {
              url
              channel
            }
          }
        }
      `}
      render={data => (
        <>
          <div className="container">
            <div className="container__sidebar">
              <img src={logo} alt="Emke Douwe" width="100%" className="logo" />
              <p>{data.datoCmsHomepage.shortDescription}</p>
              <ul className="sidebar__menu">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
              </ul>
              <p className="sidebar__social">
                {data.datoCmsHomepage.socialMedia.map((profile) => (
                  <a key={profile.channel} href={profile.url} target="blank" className={`social social--${profile.channel.toLowerCase()}`} />
                ))}
              </p>
              <p className="small">&copy; {new Date().getFullYear()} Emke Douwe - Made with DatoCMS</p>
            </div>
            <div className="container__body">
              <main>{children}</main>
            </div>
          </div>
        </>
      )}
    />
  )
}

export default Layout